
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 18.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v13zM21.5 5h-1a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5zm-8 0a.5.5 0 00-.5.5v11a.5.5 0 001 0v-11a.5.5 0 00-.5-.5zm-7 0a.5.5 0 00-.5.5v11a.5.5 0 001 0v-11a.5.5 0 00-.5-.5zm11 0h-1a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5zm-6.5.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-11z"}})])
          )
        }
      }
    